module.exports = __webpack_public_path__ + "img/new_customer.ca858a9a.png";